<script setup lang="ts">
  import Survey from '@/core/store/survey/surveyStore';
  import SurveyItemSection  from './itemsComponents/surveyItemSection.vue';
  import { DisplayType, FieldType, FormDesignItemDto, FormSectionDesignDto } from '../../../core/store/survey/surveyDesignDtos';
  import { computed, Ref, ComputedRef } from 'vue';
import { sec } from 'mathjs';
import { Sh } from '@/core/sharedService';
  const { selectItem, selectedSectionId, selectedItemId, isDesign, displayMode, currentDesign } = Survey();
  const itemsOrganized: Ref<FormSectionDesignDto[]> = computed<FormSectionDesignDto[]>(() => {
      const items = currentDesign.value.items;
      if(items== null || items.length == 0 ) return [];
      const sections: FormSectionDesignDto[] = items.filter(i => [FieldType.SECTION.toString(), FieldType.NEWPAGE.toString()].includes(i.type)).map(i => ({
        order: i.order,
        break: i.type == FieldType.NEWPAGE.toString(),
        section: i,
        items: []
      })).sort((i1,i2) => i1.order - i2.order);
 
      for(const i of items.filter(i=> ![FieldType.SECTION.toString(), FieldType.NEWPAGE.toString()].includes(i.type)).sort((i1, i2) => i1.order - i2.order)){
        const sect = sections.find(s => s.section.id == i.parentItemId);
        if(!sect) continue;
        sect.items.push(i);
      }
      return sections;
    }); 
  const isVisible = (section: FormDesignItemDto): boolean => {
    if(isDesign && displayMode.value == DisplayType.EDIT) return true;
    switch(displayMode.value) {
      case DisplayType.DISPLAY:
        if (section.properties && section.properties.screen && section.properties.screen.visible) {
          return true;
        }
        break;
      case DisplayType.EDIT:
        if (section.properties && section.properties.input && section.properties.input.visible) {
          return true;
        }
        break;
      case DisplayType.PDF:
        if (section.properties && section.properties.print && section.properties.print.visible) {
          return true;
        }
        break;
    }
    
    return false;
  };

</script>

<template>
  <div v-if="itemsOrganized" class="surveyContainer">
    <div v-for="section of itemsOrganized" :key="section.section.id" :style="selectedSectionId == section.section.id ?  {borderRadius: '25px',} : {border: 'none'} ">
      <div v-if="isDesign && displayMode == DisplayType.EDIT">
        <SurveyItemSection :section="section" />
        <hr v-if="isDesign && displayMode != DisplayType.EDIT" class="sectionSeparatorNoVisible">
        <hr class="sectionSeparator">
        <div v-if="section.break" 
            :class="[selectedItemId == section.section.id ? 'dashed-line-selected' : 'dashed-line']" 
            v-on:click="selectItem(section.section.id)">
          &nbsp;
        </div>
      </div>
      <div v-else-if="isVisible(section.section) || Sh.isDebug" 
           :class="[selectedSectionId == section.section.id ? 'sectionSelected' : 'section']"
           v-on:click="selectItem(section.section.id)"> 
        <div v-if="section.break">
          <div v-if="section.section.type === FieldType.NEWPAGE.toString()" 
              :class="[selectedItemId == section.section.id ? 'dashed-line-selected' : 'dashed-line']" 
              v-on:click="selectItem(section.section.id)">&nbsp;</div>
        </div>
        <div v-else>
          <SurveyItemSection :section="section" />
          <hr v-if="isDesign && displayMode != DisplayType.EDIT" class="sectionSeparatorNoVisible">
          <hr class="sectionSeparator">
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  @import url(./survey.scss);
</style>

<script lang="ts">
  export default {
    name: "SurveyContent"
  }
</script>